import { Entity, Improvement } from '../../..'

// Improvement Body
// TODO: change these types once we are able to edit the frontend!
export interface Body extends FormattedNegativeKeyword {
    blocked_positive_keywords: FormattedPositiveKeyword[]
    is_dismissed: boolean
}

interface FormattedKeyword {
    keyword_id: number
    match_type: 'exact' | 'phrase' | 'broad'
    containing_id: number // can be from ad_group, campaign or shared_set
}

export type ContainerLocationEntity =
    | typeof Entity.EntityLocation.AdGroup
    | typeof Entity.EntityLocation.Campaign
    | typeof Entity.EntityLocation.NegativeList

export interface FormattedPositiveKeyword extends FormattedKeyword {
    criteria_resource_name: string
    positive_keyword_text: string // formatted like this
    formatted_positive_text: string // [formatted like this] | "or this" | +or +this
    ad_group_id: number
    ad_group_name: string
    campaign_id: number
    campaign_name: string
}

export interface FormattedNegativeKeyword extends FormattedKeyword {
    criterion_resource_name: string
    negative_keyword_text: string // formatted like this
    formatted_negative_text: string // [formatted like this] | "or this" | +or +this
    container_type: ContainerLocationEntity
    container_name: string
}

export interface BlockingNegative extends FormattedNegativeKeyword {
    positive_keyword: FormattedPositiveKeyword
}

export interface ExtraDetails {
    details: {
        blocking_negative: Body
        pause_positive_keywords: boolean
    }
}

// Errors
export type Error = (typeof Error)[keyof typeof Error]

export const Error = {
    NO_KEYWORDS_WITH_ZERO_IMPRESSIONS: 'no_keywords_with_zero_impressions',
    NO_BLOCKING_KEYWORDS: 'no_blocking_keywords',
    FAILED_TO_RETRIEVE_EXTRA_DETAILS: 'failed_to_retrieve_extra_details',
    BLOCKING_KEYWORDS_INVALID_COUNT: 'invalid_count_of_blocking_keyword_conflicts',
}

export const ErrorReadable = {
    [Error.NO_KEYWORDS_WITH_ZERO_IMPRESSIONS]: 'No keywords with zero impressions were found',
    [Error.NO_BLOCKING_KEYWORDS]: 'No blocking keywords were found',
    [Error.FAILED_TO_RETRIEVE_EXTRA_DETAILS]: 'Failed to retrieve extra details',
    [Error.FAILED_TO_RETRIEVE_EXTRA_DETAILS]: 'Invalid count of blocking keyword conflicts',
}

// Generate No Imp Messages
export const NoImprovementMessage = {
    NO_IMPROVEMENTS: 'no_improvement',
}

// Rec Actions
export const RecActions = {
    FIX_NEGATIVES_BLOCKING_KEYWORDS: Improvement.RecAction.FixNegativesBlockingKeywords,
}
